import React from "react"
import { Form, Row, Col } from "react-bootstrap"
// import Select from "react-select";
import { Typeahead } from 'react-bootstrap-typeahead';
import InputError from "../../InputError/InputError"
import "./Forms.css"

function TypeAhead({
    id,
    required,
    type,
    formLabel,
    size,
    options,
    name,
    value,
    onChange,
    isError,
    errorMessage = "",
    className,
    disabled,
    onInputChange,
    inputValue,
    onKeyDown
}) {
  return (
    <Form>
      {type === "inline" ? (
        <Form.Group className="mb-3" controlId="formBasicEmail">
          <Row>
            <Col sm={4}>
              <Form.Label className="form-label align-left">
                {formLabel}
                {required && <span className="badge">*</span>}
              </Form.Label>
            </Col>
            <Col sm={6}>
              <Typeahead
                id={id}
                options={options}
                value={value}
                onChange={(text) => onChange(text)}
                isDisabled={disabled}
                size={size}
                onInputChange={onInputChange}
                inputValue={inputValue}
                onKeyDown={onKeyDown}
              />
              <InputError
                isValid={isError}
                message={errorMessage !== "" ? errorMessage : "*Required"}
              />
            </Col>
          </Row>
        </Form.Group>
      ) : (
        <Form.Group className="mb-3" controlId="formBasicEmail">
          <Form.Label className="align-left form-label">
            {formLabel}
            {required && <span className="badge">*</span>}
          </Form.Label>
          <Typeahead
            id={id}
            options={options}
            value={value}
            onChange={(text) => onChange(text)}
            isDisabled={disabled}
            size={size}
            onInputChange={onInputChange}
            inputValue={inputValue}
            onKeyDown={onKeyDown}
          />
          <InputError
            isValid={isError}
            message={errorMessage !== "" ? errorMessage : "*Required"}
          />
        </Form.Group>
      )}
    </Form>
  )
}

export default TypeAhead
